/** Frame patches driven by execution events. */
import type { FrameStatus } from "@/api/spaces";
import type { FrameData } from "@/lib/frame-data";
import { useFramesStore, type FramePatchEntry } from "@/stores/frames-store";

function patchMatchingFrames(
  patchFor: (frame: FrameData) => FramePatchEntry[1] | null,
): void {
  const { framesById, frameOrder, patchFrames } = useFramesStore.getState();
  const entries: FramePatchEntry[] = [];
  for (const id of frameOrder) {
    const frame = framesById[id];
    const patch = frame ? patchFor(frame) : null;
    if (patch) entries.push([id, patch]);
  }
  if (entries.length > 0) patchFrames(entries);
}

function executionIdOf(frame: FrameData): unknown {
  return frame.metadata?.execution_id;
}

/** Mark every streaming frame done — safety net for execution completion. */
export function finalizeStreamingFrames(): void {
  patchMatchingFrames((frame) =>
    frame.status === "streaming" ? { status: "done" } : null,
  );
}

/** Mark the streaming frames of one execution as failed. */
export function failExecutionFrames(executionId: string): void {
  const status: FrameStatus = "error";
  patchMatchingFrames((frame) =>
    frame.status === "streaming" && executionIdOf(frame) === executionId
      ? { status }
      : null,
  );
}
